var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolboxDimpleBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 24,
    viewBox: "0 0 9 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.11874 8.51178C6.70625 5.73809 9 2.90083 9 1.07324e-07L9 24C9 21.1342 6.76133 18.4737 2.28398 16.0185C0.125272 14.8347 -0.637883 12.1734 0.57942 10.0742C0.949505 9.43596 1.47888 8.89865 2.11874 8.51178Z",
    fill: "#2c3041"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolboxDimpleBlue);
export default __webpack_public_path__ + "static/media/toolbox-dimple-blue.fc0b93ca53e7f3b28ccb8daa10ad20ea.svg";
export { ForwardRef as ReactComponent };